<template>
    <div class="bg-white px-3 index">
        <div class="add_tits" ref="titles">
            <el-form class="form-inlines u-f u-jsb" :inline="true">
                <div>
                    <el-form-item label="模糊搜索">
                        <el-select v-model="lb_value" placeholder="请选择" size="small" filterable clearable>
                            <el-option v-for="item in  lb_options" :key="item.id" :label="item.name" :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" icon="el-icon-search" size="small" @click="begin">搜索</el-button>
                    </el-form-item>
                </div>
                <div>
                    <el-form-item>
                        <el-button type="primary" icon="el-icon-circle-plus-outline" size="small" @click="handleAdd">新增
                        </el-button>
                    </el-form-item>
                </div>
            </el-form>
        </div>
        <div class="ibox-content">
            <el-table :data="tableData" border v-loading="loading" :height="heights" class="">
                <el-table-column prop="id" label="编号"></el-table-column>
                <el-table-column prop="name" label="活动标题" show-overflow-tooltip></el-table-column>
                <el-table-column prop="content" label="活动封面">
                    <template slot-scope="scope">
                        <div class="u-f u-wrap" v-if="scope.row.file">
                            <div v-for="(item,index) in scope.row.file" :key="index" @click="goprev(item)">
                                <img :src="item.url" alt="" width="50" class="tablimg">
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="sort" label="排序"></el-table-column>
                <el-table-column prop="create_time" label="添加时间" show-overflow-tooltip></el-table-column>
                <el-table-column prop="create_time" label="投票详情" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <el-link type="primary" @click="openvotedetail(scope.row,scope.$index)">查看</el-link>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="200" align="center">
                    <template slot-scope="scope">
                        <el-button size="mini" type="primary" icon="el-icon-edit-outline"
                            @click="handleEdit(scope.row,scope.$index)"></el-button>
                        <!-- <el-button size="mini" type="success" @click="handleComment(scope.$index, scope.row)">评论</el-button> -->
                        <el-button size="mini" type="danger" icon="el-icon-delete"
                            @click="handleDelet(scope.row,scope.$index)"></el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="u-f u-ac u-jsb ft_mr">
                <div></div>
                <div>
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                        :current-page="currentPage" :page-sizes="[15, 30, 50, 100]" :page-size="pagesize"
                        layout="total, sizes, prev, pager, next, jumper" :total="count">
                    </el-pagination>
                </div>
            </div>
        </div>
        <el-dialog title="活动展示设置" :visible.sync="dialogVisible" center top="20px" width="80%" class="dialogs">
            <el-divider></el-divider>
            <div class="dialog-ibox-content u-f">
                <div class="left">
                    <el-form :model="ruleForm" :rules="rule" ref="ruleForm" label-width="150px"
                        class="demo-ruleForm forms-lines">
                        <el-form-item label="">
                            <el-button @click="outopenvote">插入投票</el-button>
                            <el-button @click="outopenguess">插入猜想</el-button>
                        </el-form-item>
                        <el-form-item label="活动类别" prop='lb_value'>
                            <el-select v-model="ruleForm.lb_value" placeholder="请选择" size="small" filterable>
                                <el-option v-for="item in  lb_options" :key="item.id" :label="item.name"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="活动位置">
                            <el-select v-model="ruleForm.wz_value" placeholder="请选择活动处于位置" size="small" filterable>
                                <el-option v-for="item in  wz_options" :key="item.id" :label="item.name"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="活动时间">
                            <el-date-picker v-model="ruleForm.times" type="daterange" range-separator="至" size="small"
                                :clearable="false" start-placeholder="开始日期" end-placeholder="结束日期"
                                value-format="yyyy-MM-dd">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="活动标题" prop='lb_title'>
                            <el-input v-model="ruleForm.lb_title" size="small"></el-input>
                        </el-form-item>
                        <el-form-item label="关键词">
                            <div class="u-f u-ac">
                                <el-input v-model="ruleForm.keyword" size="small" placeholder="用顿号分割(、)"></el-input>
                                <el-tag type="success">用顿号分割(、)</el-tag>
                            </div>
                        </el-form-item>
                        <el-form-item label="活动封面" required>
                            <el-upload class="avatar-uploader" action="/admin/uploadFile" name="img" ref="upload"
                                :headers="{ token:$store.state.user.token }"
                                :data="{ image_class_id:'72',file_type:'1' }" :file-list="ruleForm.lb_mapList"
                                :on-success="uploadSuccess" :on-remove="uploadRmove" list-type="picture-card">
                                <i class="el-icon-plus"></i>
                            </el-upload>
                        </el-form-item>
                        <el-form-item label="活动内容">
                            <tinymce ref="editor" v-model="ruleForm.lb_content" @onClick="onClick"
                                toolbar="undo redo |  formatselect | bold italic  | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent  | removeformat | imageUpload" />
                        </el-form-item>
                        <el-form-item label="">
                            <el-button @click="addcontent">插入</el-button>
                        </el-form-item>
                        <el-form-item label="免责声明">
                            <el-select v-model="ruleForm.lb_state" placeholder="请选择" size="small">
                                <el-option v-for="item in state_options" :key="item.id" :label="item.content_name"
                                    :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="排序" prop='lb_sort'>
                            <el-input v-model="ruleForm.lb_sort" size="small" type="number"> </el-input>
                        </el-form-item>
                        <el-form-item label="发布设置" prop='lb_put'>
                            <el-radio-group v-model="ruleForm.lb_put">
                                <el-radio label="1" style="width:100%;margin-bottom:0px">立即发布</el-radio>
                                <div>
                                    <el-radio label="2">定时发布</el-radio>
                                    <el-date-picker v-model="ruleForm.lb_dstime" :clearable="false"
                                        :disabled="ruleForm.lb_put==2?false:true" size="mini" type="datetime"
                                        value-format="yyyy-MM-dd HH:mm" placeholder="选择日期时间" default-time="12:00:00">
                                    </el-date-picker>
                                </div>
                                <el-radio label="3" style="width:100%">暂不发布</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="right">
                    <div class="content">
                        <h3>{{ruleForm.lb_title}}</h3>
                        <!-- 顶部 -->
                        <div style="text-align:right;padding:3px 0">
                            <el-popover placement="top" width="350" v-model="topinsetinto" trigger="click">
                                <div style="text-align: right; margin: 0">

                                    <el-button class="insetbtn" @click="openvote(-1)">插入投票</el-button>
                                    <el-button class="insetbtn" @click="openguess(-1)">插入猜想</el-button>
                                    <el-button class="insetbtn" @click="opentext(-1)">插入内容</el-button>
                                </div>
                                <el-button slot="reference" icon="el-icon-plus" size="mini" title="插入" circle>
                                </el-button>
                            </el-popover>
                        </div>
                        <div v-for="(item,index) in article" :key='index' class="cont">
                            <!-- 内容 -->
                            <div v-if="item.type=='html'">
                                <div class='text' v-html="item.content"></div>
                                <div style="text-align:right;padding:3px 0">
                                    <el-button icon="el-icon-edit" @click="edittext(item,index)" class="insetbtn"
                                        type="primary" size="mini" title="修改" circle>
                                    </el-button>
                                    <el-popover placement="top" width="350" v-model="item.insetdia" trigger="click">
                                        <div style="text-align: right; margin: 0">
                                            <el-button @click="openvote(index)">插入投票</el-button>
                                            <el-button @click="openguess(index)">插入猜想</el-button>
                                            <el-button @click="opentext(index)">插入内容</el-button>
                                        </div>
                                        <el-button slot="reference" class="insetbtn" icon="el-icon-plus" size="mini"
                                            title="插入" circle>
                                        </el-button>
                                    </el-popover>
                                    <el-button type="danger" icon="el-icon-delete" @click="deltp(item,index)"
                                        size="mini" title="删除内容" class="insetbtn" circle></el-button>
                                </div>
                            </div>
                            <!-- 投票 -->
                            <div v-if="item.type=='component' && item.name=='Vote'">
                                <div class='text'>
                                    <component :is="Vote" :voteId="item.params.voteId" :key='item.params.voteId'
                                        :articleId="articleId"></component>
                                </div>
                                <div style="text-align:right;padding:3px 0">
                                    <el-popover placement="top" width="350" v-model="item.insetdia" trigger="click">
                                        <div style="text-align: right; margin: 0">
                                            <el-button @click="openvote(index)">插入投票</el-button>
                                            <el-button @click="openguess(index)">插入猜想</el-button>
                                            <el-button @click="opentext(index)">插入内容</el-button>
                                        </div>
                                        <el-button slot="reference" class="insetbtn" icon="el-icon-plus" size="mini"
                                            title="插入" circle>
                                        </el-button>
                                    </el-popover>
                                    <el-button type="danger" icon="el-icon-delete" @click="deltp(item,index)"
                                        size="mini" title="删除投票" class="insetbtn" circle></el-button>
                                </div>
                            </div>
                            <!-- 猜想 -->
                            <div v-if="item.type=='component' && item.name=='Guess'">
                                <div class='text'>
                                    <component :is="Guess" :guessId="item.params.guessId" :key='item.params.guessId'
                                        :articleId="articleId">
                                    </component>
                                </div>
                                <div style="text-align:right;padding:3px 0">
                                    <el-popover placement="top" width="350" v-model="item.insetdia" trigger="click">
                                        <div style="text-align: right; margin: 0">
                                            <el-button @click="openvote(index)">插入投票</el-button>
                                            <el-button @click="openguess(index)">插入猜想</el-button>
                                            <el-button @click="opentext(index)">插入内容</el-button>
                                        </div>
                                        <el-button slot="reference" class="insetbtn" icon="el-icon-plus" size="mini"
                                            title="插入" circle>
                                        </el-button>
                                    </el-popover>
                                    <el-button type="danger" icon="el-icon-delete" @click="deltp(item,index)"
                                        size="mini" title="删除猜想" class="insetbtn" circle></el-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
                <el-button @click="submit('ruleForm')" size="small" type="primary" :loading="subloading">提 交</el-button>
                <el-button @click="dialogVisible = false" size="small">取 消</el-button>
            </span>
        </el-dialog>
        <!--  -->
        <el-dialog :visible.sync="dialog_prev" width="60vw" top="5vh">
            <div style="margin: -60px -20px -30px -20px;">
                <img :src="urls" class="w-100" />
            </div>
        </el-dialog>
        <!-- 插入投票 插入猜想 -->
        <el-dialog :title="vote?'插入投票':'插入猜想'" @close='closeinset' :visible.sync="votedialogVisible" top="120px"
            width="40%" class="dialogs">
            <el-divider></el-divider>
            <div class="dialog-ibox-content" v-if="vote">
                <div class="toptip">
                    <el-button @click="addvote">新建投票</el-button>
                </div>
                <el-table :data="votetableData" border v-loading="loading" highlight-current-row
                    @current-change="handleCurrentChange2" @row-click='selectrow' :height="height"
                    class="tableLimit votebox">
                    <el-table-column prop="vote_name" label="投票名称"></el-table-column>
                    <el-table-column prop="deadline" label="截止时间" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <span v-if="scope.row.voteEnd==1" style="color:red">已过期</span>
                            <span v-else>{{scope.row.deadline}}</span>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column prop="create_time" label="投票人数" show-overflow-tooltip></el-table-column> -->
                    <el-table-column label="操作" width="220" align="center">
                        <template slot-scope="scope">
                            <el-button size="mini" type="primary" @click="voteedit(scope.row,scope.$index)">编辑
                            </el-button>
                            <el-button size="mini" type="success" @click="votedetail(scope.row,scope.$index)">详情
                            </el-button>
                            <el-button size="mini" type="danger" @click="delvote(scope.row,scope.$index)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="dialog-ibox-content" v-else>
                <div class="toptip">
                    <el-button @click="addvote">新建猜想</el-button>
                </div>
                <el-table :data="votetableData" border v-loading="loading" highlight-current-row
                    @current-change="guesshandleCurrentChange2" :height="height" class="tableLimit votebox">
                    <el-table-column prop="question_name" label="猜想名称"></el-table-column>
                    <!-- <el-table-column prop="deadline" label="截止时间" show-overflow-tooltip></el-table-column> -->
                    <el-table-column prop="update_time" label="更新时间" show-overflow-tooltip></el-table-column>
                    <el-table-column label="操作" width="220" align="center">
                        <template slot-scope="scope">
                            <el-button size="mini" type="primary" @click="guessedit(scope.row,scope.$index)">编辑
                            </el-button>
                            <el-button size="mini" type="success" @click="guessdetail(scope.row,scope.$index)">详情
                            </el-button>
                            <el-button size="mini" type="danger" @click="delguess(scope.row,scope.$index)">删除
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="u-f u-ac u-jsb ft_mr">
                <div></div>
                <div>
                    <el-pagination @size-change="insethandleSizeChange" @current-change="insethandleCurrentChange"
                        :current-page="insetcurrentPage" :page-sizes="[10, 30, 50, 100]" :page-size="insetpagesize"
                        layout="total, sizes, prev, pager, next, jumper" :total="insetcount">
                    </el-pagination>
                </div>
            </div>
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
                <el-button @click="insetvote" size="small" type="primary">确 定</el-button>
                <el-button @click="votedialogVisible = false" size="small">取 消</el-button>
            </span>
        </el-dialog>
        <!-- 新建投票  新建猜想-->
        <el-dialog :title="voteandguesstit" :visible.sync="addvotedialogVisible" top="50px" width="50%" class="dialogs">
            <el-divider></el-divider>
            <div class="dialog-ibox-content" v-if="vote">
                <el-form :model="voteruleForm" :rules="problems" ref="voteruleForm" label-width="150px"
                    class="demo-ruleForm forms-lines">
                    <el-form-item label="投票名称" prop='vote_name'>
                        <el-input v-model="voteruleForm.vote_name" size="small"></el-input>
                    </el-form-item>
                    <el-form-item label="截止时间" style="margin-top:10px" prop='deadline'>
                        <el-date-picker v-model="voteruleForm.deadline" :clearable="false" size="mini" type="datetime"
                            value-format="yyyy-MM-dd HH:mm" placeholder="选择日期时间" default-time="12:00:00">
                        </el-date-picker>
                    </el-form-item>
                    <div class="problem_box" v-for="(p,index) in voteruleForm.problems" :key="index">
                        <el-form-item label="标题" style="margin-top:10px" :prop="'problems.' + index + '.problem'"
                            :rules="problems.problem">
                            <el-input v-model="p.problem" size="small"></el-input>
                            <!-- <el-upload class="avatar-uploader" action="/admin/uploadFile" name="img" ref="upload"
                                :headers="{ token:$store.state.user.token }"
                                :data="{ image_class_id:'72',file_type:'1' }" :file-list="voteruleForm.tit_mapList"
                                :on-success="voteuploadSuccess" :on-remove="voteuploadRmove" list-type="picture-card">
                                <i class="el-icon-plus"></i>
                            </el-upload> -->
                        </el-form-item>
                        <el-form-item :label="'选项'+(ind+1)" v-for="(o,ind) in p.options" :key="ind"
                            style="margin-top:15px" required>
                            <el-input v-model="o.option" size="small"></el-input>
                        </el-form-item>
                        <el-form-item v-if="index!=0" style="margin-top:15px;text-align:right;">
                            <el-button size="mini" type="danger" @click="delpro(p)">删除问题</el-button>
                        </el-form-item>
                    </div>
                    <div class="addpro">
                        <el-form-item style="margin-top:15px">
                            <el-button icon="el-icon-plus" @click="addpro">添加问题</el-button>
                        </el-form-item>
                    </div>
                </el-form>
            </div>
            <div class="dialog-ibox-content" v-else>
                <el-form :model="voteruleForm" :rules="guessrule" ref="voteruleForm" label-width="150px"
                    class="demo-ruleForm forms-lines">
                    <div class="problem_box">
                        <el-form-item label="标题" style="margin-top:10px" prop='guesstit'>
                            <el-input v-model="voteruleForm.guesstit" size="small"></el-input>
                            <el-upload class="avatar-uploader" action="/admin/uploadFile" name="img" ref="upload"
                                :limit="1" :headers="{ token:$store.state.user.token }"
                                :data="{ image_class_id:'72',file_type:'1' }" :file-list="voteruleForm.guesstit_mapList"
                                :on-success="guessuploadSuccess" :on-remove="guessuploadRmove" list-type="picture-card">
                                <i class="el-icon-plus"></i>
                            </el-upload>
                        </el-form-item>
                        <el-form-item label="选项" prop='options' style="margin-top:20px">
                            <el-input type="textarea" :rows="4" placeholder="请输入内容" v-model="voteruleForm.options">
                            </el-input>
                        </el-form-item>
                        <el-form-item label="答案" prop='answer' style="margin-top:15px">
                            <el-input v-model="voteruleForm.answer" size="small"></el-input>
                        </el-form-item>
                        <el-form-item label="答案详情" prop='answerdetail' style="margin-top:15px">
                            <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="voteruleForm.answerdetail">
                            </el-input>
                        </el-form-item>
                    </div>
                </el-form>
            </div>
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
                <el-button @click="votesubmit('voteruleForm')" size="small" type="primary" :loading="subloading">确 定
                </el-button>
                <el-button @click="addvotedialogVisible = false" size="small">取 消</el-button>
            </span>
        </el-dialog>
        <!-- 投票详情  猜想详情-->
        <el-dialog :title="vote?'投票详情':'猜想详情'" :visible.sync="votedetaildialogVisible" top="50px" width="50%"
            class="dialogs">
            <el-divider></el-divider>
            <div class="dialog-ibox-content" v-if="vote">
                <el-form :model="voteruleForm" :rules="voterule" ref="voteruleForm" label-width="150px"
                    class="demo-ruleForm forms-lines">
                    <el-form-item label="投票名称：">
                        <span>{{voteruleForm.vote_name}}</span>
                    </el-form-item>
                    <el-form-item label="截止时间：" style="margin-top:10px">
                        <span>{{voteruleForm.deadline}}</span>
                    </el-form-item>
                    <div class="problem_box" v-for="(p,index) in voteruleForm.problems" :key="index">
                        <el-form-item label="标题：" style="margin-top:10px">
                            <span>{{p.problem}}</span>
                        </el-form-item>
                        <el-form-item :label="o.option" v-for="(o,ind) in p.options" :key="ind" style="margin-top:15px">
                            <div style="margin-top:10px">
                                <el-progress :percentage="o.choice_lv"></el-progress>
                            </div>
                        </el-form-item>
                    </div>
                </el-form>
            </div>
            <div class="dialog-ibox-content" v-else>
                <el-form :model="voteruleForm" :rules="voterule" ref="voteruleForm" label-width="150px"
                    class="demo-ruleForm forms-lines">
                    <el-form-item label="标题:" style="margin-top:10px" prop='guesstit'>
                        <span>{{voteruleForm.guesstit}}</span>
                        <div>
                            <div v-for="(img,index) in voteruleForm.guesstit_mapList" :key="index" style="width:200px">
                                <img :src="img.url" alt="" style="width:100%">
                            </div>
                        </div>
                    </el-form-item>
                    <el-form-item label="选项:" prop='options' style="margin-top:20px">
                        <span>{{voteruleForm.options}}</span>
                    </el-form-item>
                    <el-form-item label="答案:" prop='answer' style="margin-top:15px">
                        <span>{{voteruleForm.answer}}</span>
                    </el-form-item>
                    <el-form-item label="答案详情:" prop='answerdetail' style="margin-top:15px">
                        <span>{{voteruleForm.answerdetail}}</span>
                    </el-form-item>
                </el-form>
            </div>
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
                <el-button @click="votedetaildialogVisible = false" size="small">确定</el-button>
            </span>
        </el-dialog>
        <!-- 插入内容-->
        <el-dialog title="插入内容" :visible.sync="textdialogVisible" top="50px" width="50%" class="dialogs">
            <el-divider></el-divider>
            <div class="dialog-ibox-content">
                <tinymce ref="editor" v-model="text_content" @onClick="onClick"
                    toolbar="undo redo |  formatselect | bold italic  | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent  | removeformat | imageUpload" />
            </div>
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
                <el-button @click="insetintotext" size="small">确定</el-button>
            </span>
        </el-dialog>
        <!-- 文章投票-->
        <el-dialog title="此活动内投票列表" :visible.sync="contentvotedetail" top="50px" width="60%" class="dialogs">
            <el-divider></el-divider>
            <Contentvotelist ref="votelist" />
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
                <el-button @click="contentvotedetail=false" size="small">确定</el-button>
            </span>
        </el-dialog>
        <!-- 投票人员列表-->
        <el-dialog title="投票人员列表" :visible.sync="uservotelist" top="70px" width="50%" class="dialogs">
            <el-divider></el-divider>
            <Voteuser ref="uservotelist" />
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
                <el-button @click="uservotelist=false" size="small">确定</el-button>
            </span>
        </el-dialog>

        <!-- 用户投票纪录-->
        <el-dialog title="用户投票纪录" :visible.sync="uservoterecord" top="50px" width="50%" class="dialogs">
            <el-divider></el-divider>
            <Uservoterecord ref="voterecord" />
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
                <el-button @click="uservoterecord=false" size="small">确定</el-button>
            </span>
        </el-dialog>

        <!--  -->
        <el-dialog title="评论设置" :visible.sync="dialogs" top="80px" width="60%" center class="dialogs">
            <el-divider></el-divider>
            <div class="dialog-ibox-content">
                <comment ref="coms"></comment>
            </div>
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogs = false" size="small">取 消</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
    import {
        mapState
    } from 'vuex'
    import tinymce from '@/components/common/tinymce.vue';
    import Contentvotelist from '../../../components/contentvotelist/vote';
    import Voteuser from '../../../components/contentvotelist/voteuser';
    import comment from '@/components/header/comment.vue';
    import Uservoterecord from '../../../components/contentvotelist/uservotelist';
    export default {
        components: {
            tinymce,
            Contentvotelist,
            Voteuser,
            Uservoterecord,
            comment
        },
        data() {
            return {

                topinsetinto: false,
                vote: true,
                articleId: 6,
                article: [

                ],
                voteandguesstit: '',
                lb_value: '',
                lb_options: [],
                loading: false,
                tableData: [],
                votetableData: [],
                count: 0,
                currentPage: 1,
                pagesize: 15,
                height: null,
                heights: null,
                // 
                eid: '0',
                activityId: '0',
                dialogVisible: false,
                votedetaildialogVisible: false,
                uservoterecord: false,
                contentvotedetail: false,
                uservotelist: false,
                subloading: false,

                ruleForm: {
                    lb_title: '',
                    lb_value: '',
                    wz_value: '',
                    lb_content: '',
                    lb_sort: 50,
                    lb_put: '1',
                    lb_dstime: '',
                    lb_mapList: [],
                    keyword: '',
                    lb_state: '',
                    times: '',
                },
                voteruleForm: {
                    guesstit: '',
                    options: '',
                    answer: '',
                    answerdetail: '',
                    guesstit_mapList: [],

                    tit_mapList: [],

                    deadline: '',
                    vote_name: '',
                    problems: [{
                        problem: "",
                        choose_type: 1,
                        options: [{
                                option: ""
                            },
                            {
                                option: ""
                            },
                            {
                                option: ""
                            },
                            {
                                option: ""
                            }
                        ]
                    }],
                },
                wz_options: [{
                        id: 1,
                        name: '第一位置'
                    },
                    {
                        id: 2,
                        name: '第二位置'
                    },
                    {
                        id: 3,
                        name: '第三位置'
                    },
                ],

                votetit_mapList: [],
                guesstit_mapList: [],
                voterule: {

                    vote_title2: [{
                        required: true,
                        message: '请填写投票标题',
                        trigger: 'blur'
                    }],

                    xx1: [{
                        required: true,
                        message: '请填写选项1内容',
                        trigger: 'blur'
                    }],
                    xx2: [{
                        required: true,
                        message: '请填写选项2内容',
                        trigger: 'blur'
                    }],
                    xx3: [{
                        required: true,
                        message: '请填写选项3内容',
                        trigger: 'blur'
                    }],
                    xx4: [{
                        required: true,
                        message: '请填写选项4内容',
                        trigger: 'blur'
                    }],
                },
                guessrule: {
                    guesstit: [{
                        required: true,
                        message: '请填写猜想标题',
                        trigger: 'blur'
                    }],
                    options: [{
                        required: true,
                        message: '请填写猜想选项',
                        trigger: 'blur'
                    }],

                    answer: [{
                        required: true,
                        message: '请填写猜想答案',
                        trigger: 'blur'
                    }],
                    answerdetail: [{
                        required: true,
                        message: '请填写详细答案',
                        trigger: 'blur'
                    }],

                },
                mapListed: [],
                state_options: [],
                rule: {
                    wz_value: [{
                        required: true,
                        message: '请选择活动处于位置',
                        trigger: 'blur'
                    }],
                    lb_value: [{
                        required: true,
                        message: '请填写图文类别',
                        trigger: 'blur'
                    }],
                    lb_title: [{
                        required: true,
                        message: '请填写图文标题',
                        trigger: 'blur'
                    }],

                    lb_content: [{
                        required: true,
                        message: '请填写图文内容',
                        trigger: 'blur'
                    }],
                    lb_sort: [{
                        required: true,
                        message: '请填写排序',
                        trigger: 'blur'
                    }],
                    lb_put: [{
                        required: true,
                        message: '请选择发布设置',
                        trigger: 'blur'
                    }],
                },
                problems: {
                    problem: [{
                        required: true,
                        message: '标题不能为空！',
                        trigger: 'blur'
                    }],
                    option: [{
                        required: true,
                        message: '*必填',
                        trigger: 'blur'
                    }, ],

                    vote_name: [{
                        required: true,
                        message: '请填写投票名称',
                        trigger: 'blur'
                    }],
                    deadline: [{
                        required: true,
                        message: '请选择时间',
                        trigger: 'blur'
                    }],

                },
                // 
                dialog_prev: false,
                votedialogVisible: false,
                addvotedialogVisible: false,
                urls: '',
                currentRow: '',
                insetindex: 0,
                text_content: '',
                textdialogVisible: false,
                isedit: false,
                iseditvoteAndguess: false,
                wuoption: true,
                insetcount: 0,
                insetpagesize: 10,
                insetcurrentPage: 1,

                // 
                dialogs: false,
            };
        },
        computed: {
            ...mapState({
                user: state => state.user.user,
            }),
            Vote() {
                return () => import('@/components/vote/Vote.vue')
            },
            Guess() {
                return () => import('@/components/vote/Guess.vue')
            }
        },
        mounted() {
            let that = this
            that.getHeight()
            that.getlbxx()
            that.getstate()
            that.begin()
        },
        methods: {
            getHeight() {
                let that = this
                var titles = that.$refs.titles.offsetHeight
                that.height = window.innerHeight - titles - 175 + 'px'
                that.heights = window.innerHeight - titles - 200 + 'px'
                window.onresize = () => {
                    var titles = that.$refs.titles.offsetHeight
                    that.height = window.innerHeight - titles - 175 + 'px'
                    that.heights = window.innerHeight - titles - 200 + 'px'
                }
            },
            // 搜索
            begin() {
                let that = this
                that.currentPage = 1
                that.pagesize = 15
                that.search()
            },
            search() {
                let that = this
                that.tableData = []
                that.loading = true
                axios.post("/admin/Activity/getShowActivitys", {
                        page: that.currentPage,
                        page_count: that.pagesize,
                        // health_category_id: that.lb_value,

                    }, {
                        token: true
                    })
                    .then(response => {
                        that.loading = false
                        that.tableData = response.data.data.list
                        that.count = response.data.data.totalCount
                    })
                    .catch(error => {})
            },
            // 获取投票
            getVotelist() {
                let that = this
                that.votetableData = []
                that.loading = true
                axios.post("/admin/Vote/voteList", {
                        page: this.insetcurrentPage,
                        page_count: this.insetpagesize,
                    }, {
                        token: true
                    })
                    .then(response => {
                        that.loading = false
                        that.votetableData = response.data.data.data
                        that.insetcount = response.data.data.count

                    })
                    .catch(error => {})
            },
            // 获取猜想
            getGuesslist() {
                let that = this
                that.votetableData = []
                that.loading = true
                axios.post("/admin/PictureQuestion/questionList", {
                        page: this.insetcurrentPage,
                        page_count: this.insetpagesize,
                    }, {
                        token: true
                    })
                    .then(response => {
                        that.loading = false
                        that.votetableData = response.data.data.data
                        that.insetcount = response.data.data.count


                    })
                    .catch(error => {})
            },
            handleSizeChange(val) {
                let that = this
                that.pagesize = val;
                that.search()
            },
            handleCurrentChange(val) {
                let that = this
                that.currentPage = val;
                that.search()
            },
            insethandleSizeChange(val) {
                let that = this
                that.insetpagesize = val;
                if (this.vote) {
                    this.getVotelist()
                } else {
                    that.getGuesslist()
                }

            },
            insethandleCurrentChange(val) {
                let that = this
                that.insetcurrentPage = val;
                if (this.vote) {
                    this.getVotelist()
                } else {
                    that.getGuesslist()
                }
            },
            handleAdd() {
                let that = this
                that.dialogVisible = true
                this.ruleForm.wz_value = ''
                that.activityId = '0'
                that.form_clear()
                this.article = []
            },
            form_clear() {
                let that = this
                that.ruleForm.lb_title = ''
                that.ruleForm.lb_value = ''
                that.ruleForm.lb_content = ''
                that.ruleForm.lb_put = '1'
                that.ruleForm.lb_dstime = ''
                that.ruleForm.lb_mapList = []
                that.ruleForm.lb_sort = 50
                that.mapListed = []
                that.ruleForm.lb_state = ''
                that.ruleForm.keyword = ''
                that.ruleForm.times = ''
            },
            // 鼠标单击的事件
            onClick(e, editor) {
                // var html="<tinymce></tinymce>"
                // this.ruleForm.lb_content.append(html)
            },
            // 添加投票、猜想 修改投票猜想
            votesubmit(formName) {
                let that = this
                var time;
                that.$refs[formName].validate((valid) => {
                    if (valid) {
                        // if (that.mapListed.length < 1) return that.$message.error('请上传图文封面');
                        that.subloading = true
                        if (this.vote) {
                            let flag = false
                            this.voteruleForm.problems.forEach(ele => {
                                ele.options.forEach(e => {
                                    if (e.option == '') {
                                        flag = true
                                        that.subloading = false
                                        return
                                    }
                                })
                            })
                            if (flag) {
                                return this.$message({
                                    message: '有选项为空！',
                                    type: 'warning'
                                });
                            }

                            let urls
                            let params

                            if (this.iseditvoteAndguess) {
                                urls = '/admin/Vote/voteUpdate'
                                params = {
                                    id: this.eid,
                                    vote_name: this.voteruleForm.vote_name,
                                    deadline: this.voteruleForm.deadline,
                                    problems: this.voteruleForm.problems,
                                    file_info: that.votetit_mapList,
                                }
                            } else {
                                urls = '/admin/Vote/voteCreate';
                                params = {
                                    vote_name: this.voteruleForm.vote_name,
                                    deadline: this.voteruleForm.deadline,
                                    problems: this.voteruleForm.problems,
                                    file_info: that.votetit_mapList,
                                }
                            }
                            that.subloading = false

                            axios.post(urls, params, {
                                    token: true
                                })
                                .then(response => {
                                    that.subloading = false
                                    if (response.data.code == '200') {
                                        that.$message.success(response.data.msg);
                                        this.addvotedialogVisible = false
                                        this.getVotelist()
                                        this.iseditvoteAndguess = false
                                        this.wuoption = true
                                    } else {
                                        that.$message.error(response.data.msg);
                                    }
                                })
                                .catch(error => {
                                    that.subloading = true
                                })
                        } else {

                            let urls
                            let params
                            if (this.iseditvoteAndguess) {
                                urls = '/admin/PictureQuestion/questionUpdate'
                                params = {
                                    id: this.eid,
                                    question_name: this.voteruleForm.guesstit,
                                    question_option: this.voteruleForm.options,
                                    file_info: that.guesstit_mapList,
                                    answer: that.voteruleForm.answer,
                                    explain: that.voteruleForm.answerdetail,
                                }
                            } else {
                                urls = '/admin/PictureQuestion/questionCreate';
                                params = {
                                    question_name: this.voteruleForm.guesstit,
                                    question_option: this.voteruleForm.options,
                                    file_info: that.guesstit_mapList,
                                    answer: that.voteruleForm.answer,
                                    explain: that.voteruleForm.answerdetail,
                                }
                            }
                            axios.post(urls, params, {
                                    token: true
                                })
                                .then(response => {
                                    that.subloading = false
                                    if (response.data.code == '200') {
                                        that.$message.success(response.data.msg);
                                        this.addvotedialogVisible = false
                                        this.getGuesslist()
                                        this.iseditvoteAndguess = false

                                    } else {
                                        that.$message.error(response.data.msg);
                                    }
                                })
                                .catch(error => {
                                    that.subloading = true
                                })
                        }

                    } else {
                        this.$alert("信息遗漏未填")
                        return false;
                    }
                });
            },
            submit(formName) {
                let that = this
                var time;
                if (that.ruleForm.lb_put == '1') {
                    time = that.gettimes()
                } else if (that.ruleForm.lb_put == '2') {
                    time = that.ruleForm.lb_dstime
                } else {
                    time = that.ruleForm.lb_put
                }
                var list = []
                list = this.article.map(ele => {
                    if (ele.type == 'component' && ele.name == 'Vote') {
                        return {
                            type: 'vote',
                            vote_id: ele.params.voteId
                        }
                    } else if (ele.type == "html") {
                        return {
                            type: 'content',
                            content: ele.content
                        }
                    } else if (ele.type == 'component' && ele.name == 'Guess') {
                        return {
                            type: 'question',
                            picture_question_id: ele.params.guessId
                        }
                    }
                })
                that.$refs[formName].validate((valid) => {
                    if (valid) {
                        if (that.mapListed.length < 1) return that.$message.error('请上传图文封面');
                        that.subloading = true
                        let urls;
                        if (this.activityId && this.activityId != '0') {
                            urls = "/admin/Activity/update"
                        } else {
                            urls = "/admin/Activity/save"
                        }
                        if (this.ruleForm.times) {
                            var start = this.ruleForm.times[0]
                            var end = this.ruleForm.times[1]
                        }
                        axios.post(urls, {
                                id: that.activityId,
                                activity_category_id: that.ruleForm.lb_value,
                                name: that.ruleForm.lb_title,
                                content: list,
                                sort: that.ruleForm.lb_sort,
                                file: that.mapListed,

                                to_show: that.ruleForm.lb_put,
                                show_time: time,
                                author: this.user.id,
                                type: '1',

                                keyword: this.ruleForm.keyword,
                                statement: that.ruleForm.lb_state,
                                position_id: this.ruleForm.wz_value,

                                start_time: start,
                                end_time: end
                            }, {
                                token: true
                            })
                            .then(response => {
                                that.subloading = false
                                if (response.data.code == '200') {
                                    that.dialogVisible = false
                                    that.search()
                                } else {
                                    that.$message.error(response.data.msg);
                                }
                            })
                            .catch(error => {
                                that.subloading = true
                            })
                    } else {
                        this.$alert("信息遗漏未填")
                        return false;
                    }
                });
            },
            guessedit(row, index) {

                this.voteandguesstit = '编辑猜想'
                this.iseditvoteAndguess = true
                this.eid = row.id
                axios
                    .post("/admin/PictureQuestion/questionRead", {
                        id: this.eid,
                    }, {
                        token: true
                    })
                    .then(res => {
                        this.voteruleForm.answerdetail = res.data.data.explain
                        this.voteruleForm.answer = res.data.data.answer
                        this.voteruleForm.options = res.data.data.question_option
                        this.voteruleForm.guesstit_mapList = res.data.data.file_info
                        this.guesstit_mapList = res.data.data.file_info
                        this.voteruleForm.guesstit = res.data.data.question_name
                        this.addvotedialogVisible = true

                    })
                    .catch(error => {})


            },
            voteedit(row, index) {
                let that = this
                this.voteandguesstit = '编辑投票'
                this.iseditvoteAndguess = true
                that.eid = row.id
                axios
                    .post("/admin/Vote/voteRead", {
                        id: that.eid,
                    }, {
                        token: true
                    })
                    .then(res => {
                        this.voteruleForm.vote_name = res.data.data.vote_name
                        this.voteruleForm.deadline = res.data.data.deadline
                        this.voteruleForm.problems = res.data.data.problems
                        that.addvotedialogVisible = true


                    })
                    .catch(error => {})
            },
            // 编辑
            handleEdit(row, index) {
                let that = this
                that.form_clear()
                this.article = []
                that.dialogVisible = true
                that.activityId = row.id
                axios
                    .post("/admin/Activity/read", {
                        id: that.activityId,
                    }, {
                        token: true
                    })
                    .then(response => {
                        var data = response.data.data
                        that.ruleForm.lb_value = data.activity_category_id
                        that.ruleForm.lb_title = data.name
                        that.ruleForm.keyword = data.keyword
                        // that.ruleForm.lb_content = data.content
                        that.ruleForm.lb_mapList = data.file ? data.file : []
                        that.mapListed = data.file ? data.file : []
                        this.ruleForm.wz_value = data.position_id
                        that.ruleForm.lb_put = data.to_show ? data.to_show.toString() : ''
                        if (data.to_show == '2') {
                            that.ruleForm.lb_dstime = data.show_time
                        }
                        that.ruleForm.lb_sort = data.sort
                        that.ruleForm.lb_state = data.statement
                        if (data.start_time && data.end_time) {
                            that.ruleForm.times = [data.start_time, data.end_time]
                        }
                        // this.article.push(obj)
                        if (data.content) {
                            let arr = data.content

                            let art = arr.map(ele => {
                                if (ele.content) {
                                    return {
                                        type: 'html',
                                        content: ele.content.replace(/\<img/gi,
                                            '<img class="richimg"'),
                                        insetdia: false,
                                    }
                                } else if (ele.vote_name) {
                                    return {
                                        type: 'component',
                                        name: 'Vote',
                                        params: {
                                            voteId: ele.id
                                        },
                                        insetdia: false,

                                    }
                                } else if (ele.question_name) {
                                    return {
                                        type: 'component',
                                        name: 'Guess',
                                        params: {
                                            guessId: ele.id
                                        },
                                        insetdia: false,

                                    }
                                }
                            })
                            this.article = art
                            this.ruleForm.lb_content = ''
                        }


                    })
                    .catch(error => {})
            },
            // 删除
            handleDelet(row, index) {
                let that = this
                this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    axios
                        .post("/admin/Activity/del", {
                            id: row.id,
                        }, {
                            token: true
                        })
                        .then(response => {
                            if (response.data.code == '200') {
                                this.$message({
                                    type: 'success',
                                    message: '删除成功!'
                                });
                                that.search()
                            } else {
                                that.$message.error(response.data.msg);
                            }
                        })
                        .catch(error => {})
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            openvotedetail(row, index) {
                this.contentvotedetail = true
                this.$nextTick(() => {
                    this.$refs.votelist.textId = row.id
                    this.$refs.votelist.getvotelist(row.id)
                    // this.$refs.votelist.votelist=row.content
                })



            },
            gettimes() {
                let nowDate = new Date();
                let year = nowDate.getFullYear();
                let month = nowDate.getMonth() + 1;
                let day = nowDate.getDate();
                let hour = nowDate.getHours(); //获取系统时，
                let min = nowDate.getMinutes(); //分
                let sec = nowDate.getSeconds(); //秒
                month = month > 9 ? month : '0' + month
                day = day > 9 ? day : '0' + day
                hour = hour > 9 ? hour : '0' + hour
                min = min > 9 ? min : '0' + min
                sec = sec > 9 ? sec : '0' + sec
                return `${year}-${month}-${day} ${hour}:${min}`;
            },
            // 类别
            getlbxx() {
                let that = this
                axios
                    .post("/admin/Activity/activityCategory", {}, {
                        token: true
                    })
                    .then(response => {
                        that.lb_options = response.data.data
                    })
                    .catch(error => {})
            },
            // 声明
            getstate() {
                let that = this
                axios
                    .post("/admin/getContentBySysTypeId", {
                        sys_id: 1,
                        type_id: 22
                    }, {
                        token: true
                    })
                    .then(response => {
                        that.state_options = response.data.data
                    })
                    .catch(error => {})
            },
            goprev(item) {
                let that = this
                that.dialog_prev = true
                that.urls = item.url
            },
            // 
            uploadSuccess(response, file, fileList) {
                let that = this
                if (response.code == "201") {
                    that.$nextTick(() => {
                        let mainImg = that.$refs.upload;
                        if (mainImg) {
                            mainImg.uploadFiles.forEach((element, index) => {
                                if (file.uid == element.uid) {
                                    mainImg.uploadFiles.splice(index, 1)
                                }
                            });
                        }
                    })
                    that.$alert(response.msg)
                    return;
                }
                that.$message({
                    message: '上传成功',
                    type: 'success'
                });
                that.mapListed.push(response.data)
            },
            uploadRmove(file, fileList) {
                var index = this.mapListed.findIndex(item => item.id == file.id)
                this.mapListed.splice(index, 1)
            },
            // 投票标题图片
            voteuploadSuccess(response, file, fileList) {
                let that = this
                if (response.code == "201") {
                    that.$nextTick(() => {
                        let mainImg = that.$refs.upload;
                        if (mainImg) {
                            mainImg.uploadFiles.forEach((element, index) => {
                                if (file.uid == element.uid) {
                                    mainImg.uploadFiles.splice(index, 1)
                                }
                            });
                        }
                    })
                    that.$alert(response.msg)
                    return;
                }
                that.$message({
                    message: '上传成功',
                    type: 'success'
                });
                that.votetit_mapList.push(response.data)
            },
            voteuploadRmove(file, fileList) {
                var index = this.votetit_mapList.findIndex(item => item.id == file.id)
                this.votetit_mapList.splice(index, 1)
            },
            // 猜想标题图片
            guessuploadSuccess(response, file, fileList) {
                let that = this
                if (response.code == "201") {
                    that.$nextTick(() => {
                        let mainImg = that.$refs.upload;
                        if (mainImg) {
                            mainImg.uploadFiles.forEach((element, index) => {
                                if (file.uid == element.uid) {
                                    mainImg.uploadFiles.splice(index, 1)
                                }
                            });
                        }
                    })
                    that.$alert(response.msg)
                    return;
                }
                that.$message({
                    message: '上传成功',
                    type: 'success'
                });
                that.guesstit_mapList.push(response.data)
            },
            guessuploadRmove(file, fileList) {
                var index = this.guesstit_mapList.findIndex(item => item.id == file.id)
                this.guesstit_mapList.splice(index, 1)
            },
            outopenvote() {
                this.insetindex = '-2'
                this.vote = true
                this.voteandguesstit = '新建投票'
                this.votedialogVisible = true
                this.insetcurrentPage = 1
                this.insetpagesize = 10
                this.getVotelist()
            },
            outopenguess() {
                this.vote = false
                this.voteandguesstit = '新建猜想'
                this.insetindex = '-2'
                this.votedialogVisible = true
                this.insetcurrentPage = 1
                this.insetpagesize = 10
                this.getGuesslist()

            },
            closeinset() {
                this.currentRow = ''
            },
            openvote(index) {
                this.insetindex = index
                this.vote = true
                this.voteandguesstit = '新建投票'
                this.votedialogVisible = true
                this.insetcurrentPage = 1
                this.insetpagesize = 10
                this.getVotelist()
            },
            openguess(index) {
                this.vote = false
                this.voteandguesstit = '新建猜想'
                this.insetindex = index
                this.votedialogVisible = true
                this.insetcurrentPage = 1
                this.insetpagesize = 10
                this.getGuesslist()

            },
            opentext(index) {
                this.isedit = false
                this.insetindex = index
                this.textdialogVisible = true
                this.text_content = ''

            },
            edittext(data, index) {
                this.isedit = true
                this.insetindex = index
                this.textdialogVisible = true
                this.text_content = data.content
            },
            handleCurrentChange2(val) {
                if (val && val.voteEnd == 1) {
                    this.$message.error('此投票已过期,请选择其他或修改时间');
                    return
                }
                this.currentRow = val;
            },
            selectrow(row) {



            },
            guesshandleCurrentChange2(val) {
                this.currentRow = val;
            },
            addvote() {
                this.voteruleForm.vote_name = ''
                this.voteruleForm.deadline = '',
                    this.voteruleForm.problems = [{
                        problem: "",
                        choose_type: 1,
                        options: [{
                                option: ""
                            },
                            {
                                option: ""
                            },
                            {
                                option: ""
                            },
                            {
                                option: ""
                            }
                        ]

                    }]
                this.addvotedialogVisible = true



            },
            addpro() {
                if (this.voteruleForm.problems.length > 2) {

                    this.$message({
                        message: '问题已达上限',
                        type: 'warning'
                    });

                    return
                }
                this.voteruleForm.problems.push({
                    problem: "",
                    choose_type: 1,
                    options: [{
                            option: ""
                        },
                        {
                            option: ""
                        },
                        {
                            option: ""
                        },
                        {
                            option: ""
                        }
                    ]
                })
            },
            delpro(item) {
                var index = this.voteruleForm.problems.indexOf(item)
                if (index !== -1) {
                    this.voteruleForm.problems.splice(index, 1)
                }
            },
            // 投票详情
            votedetail(row, index) {
                let that = this
                that.votedetaildialogVisible = true
                that.eid = row.id
                axios
                    .post("/admin/Vote/voteRead", {
                        id: that.eid,
                    }, {
                        token: true
                    })
                    .then(res => {
                        this.voteruleForm.vote_name = res.data.data.vote_name
                        this.voteruleForm.deadline = res.data.data.deadline
                        this.voteruleForm.problems = res.data.data.problems

                    })
                    .catch(error => {})
            },
            // 猜想详情
            guessdetail(row, index) {
                let that = this
                that.votedetaildialogVisible = true
                that.eid = row.id
                axios
                    .post("/admin/PictureQuestion/questionRead", {
                        id: that.eid,
                    }, {
                        token: true
                    })
                    .then(res => {
                        this.voteruleForm.answerdetail = res.data.data.explain
                        this.voteruleForm.answer = res.data.data.answer
                        this.voteruleForm.options = res.data.data.question_option
                        this.voteruleForm.guesstit_mapList = res.data.data.file_info
                        this.guesstit_mapList = res.data.data.file_info
                        this.voteruleForm.guesstit = res.data.data.question_name

                    })
                    .catch(error => {})
            },
            // 删除投票
            delvote(row, index) {
                let that = this
                this.$confirm('此操作将永久删除该投票, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    axios
                        .post("/admin/Vote/voteDel", {
                            id: row.id,
                        }, {
                            token: true
                        })
                        .then(response => {
                            if (response.data.code == '200') {
                                this.$message({
                                    type: 'success',
                                    message: '删除成功!'
                                });
                                that.getVotelist()
                            } else {
                                that.$message.error(response.data.msg);
                            }
                        })
                        .catch(error => {})
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            // 删除猜想
            delguess(row, index) {
                let that = this
                this.$confirm('此操作将永久删除该猜想, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    axios
                        .post("/admin/PictureQuestion/questionDel", {
                            id: row.id,
                        }, {
                            token: true
                        })
                        .then(response => {
                            if (response.data.code == '200') {
                                this.$message({
                                    type: 'success',
                                    message: '删除成功!'
                                });
                                that.getGuesslist()
                            } else {
                                that.$message.error(response.data.msg);
                            }
                        })
                        .catch(error => {})
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            insetvote() {
                if (!this.currentRow) {
                    this.$message({
                        message: '未选择！',
                        type: 'warning'
                    });
                    return
                }
                if (this.vote) {
                    let obj = {
                        type: 'component',
                        name: 'Vote',
                        params: {
                            voteId: this.currentRow.id
                        }
                    }

                    if (this.insetindex == '-1') {
                        this.article.unshift(obj)
                        this.votedialogVisible = false
                    } else if (this.insetindex == '-2') {
                        this.article.push(obj)
                        this.votedialogVisible = false
                    } else {
                        this.article.splice(this.insetindex + 1, 0, obj)
                        this.votedialogVisible = false
                    }


                } else {
                    let obj2 = {
                        type: 'component',
                        name: 'Guess',
                        params: {
                            guessId: this.currentRow.id
                        }
                    }

                    if (this.insetindex == '-1') {
                        this.article.unshift(obj2)
                        this.votedialogVisible = false
                    } else if (this.insetindex == '-2') {
                        this.article.push(obj2)
                        this.votedialogVisible = false
                    } else {
                        this.article.splice(this.insetindex + 1, 0, obj2)
                        this.votedialogVisible = false
                    }

                }
            },
            addcontent() {
                let obj = {
                    type: 'html',
                    content: this.ruleForm.lb_content,
                }
                this.article.push(obj)
                this.ruleForm.lb_content = ''
            },
            deltp(data, index) {
                this.$confirm('此操作将删除, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.article.splice(index, 1)
                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    });

                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });



            },
            insetintotext() {
                if (this.text_content == '') {
                    this.$message.error('不能为空！');
                    return
                }
                let obj = {
                    type: 'html',
                    content: this.text_content,
                }
                if (this.insetindex == '-1') {
                    this.article.unshift(obj)
                    this.textdialogVisible = false
                } else {
                    if (this.isedit) {
                        this.article.splice(this.insetindex, 1, obj)
                        this.textdialogVisible = false
                    } else {
                        this.article.splice(this.insetindex + 1, 0, obj)
                        this.textdialogVisible = false
                    }

                }
            },
            // 评论
            handleComment(index, row) {
                let that = this
                that.dialogs = true
                this.$nextTick(() => {
                    this.$refs.coms.eid = row.id
                    this.$refs.coms.source = 2
                    this.$refs.coms.getxx()
                })
            }
        },

    };
</script>


<style lang='scss' scoped>
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }

    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }

    .tablimg {
        margin: 2px 5px;
    }

    .toptip {
        padding: 10px 0;
        text-align: right;
    }

    .votebox {
        max-height: 500px;
        overflow-y: auto;
    }

    .problem_box {
        border: 1px dashed rgb(204, 204, 204);
        margin-top: 10px;
        padding: 0 10px 0 0;
    }

    .left {
        width: 68%;
        margin-right: 20px;
    }

    .right {
        width: 414px;
        border: 1px solid rgb(202, 202, 202);
        border-radius: 5px;

        .content {
            padding: 10px;
            height: 1126px;
            overflow-y: auto;

            .text {
                border: 1px dashed rgb(204, 204, 204);
               /deep/ img{
                    max-width: 100%;
                }
            }
        }
    }

    .insetbtn {
        margin-left: 5px;
    }

    .richimg {
        max-width: 100% !important;
    }
</style>